import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'atlas-ink-bar',
  templateUrl: './ink-bar.component.html',
  styleUrls: ['./ink-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InkBarComponent {}
